import styled, { css } from 'styled-components';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';

import MenuButton from '@hud/web-components/Menu/MenuButton';
import { themeColor } from '@hud/web-components/theme/colors';
import StyledPopover from '@hud/web-components/Popover/Popover.styles';
import {
  mdBold,
  smBold,
  xsRegular,
} from '@hud/web-components/theme/typography';
import BaseDatePicker from '@hud/web-components/DatePicker/DatePicker';
import { clickableMixin } from '@hud/web-components/theme/utils';

const Button = styled(MenuButton)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;

  white-space: nowrap;
`;

const Icon = styled(HudIcon)`
  color: ${themeColor('gray')};
`;

const Body = styled(StyledPopover.Body)`
  max-height: unset;
  background-color: ${themeColor('backgroundLight')};
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  border: 1px solid
    ${themeColor({ dark: 'transparent', light: 'strokePrimary' })};

  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  ${mdBold}
  padding-left: 8px;
`;

const Guide = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  ${xsRegular}
`;

const DotIcon = styled(HudIcon).attrs({ icon: 'other.dot', size: '16px' })<{
  icon?: never;
}>`
  color: ${themeColor('purpleHome')};
`;

const GrayDot = styled(HudIcon).attrs({ icon: 'other.dot', size: '10px' })<{
  icon?: never;
}>`
  color: ${themeColor('textTertiary')};
  margin: 0 2px;
`;

const Divider = styled.div`
  border-top: 1px solid ${themeColor('strokePrimary')};
`;

const Content = styled.div`
  display: flex;
  gap: 16px;
`;

const Menu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const MenuOption = styled.button<{ $selected?: boolean }>`
  ${smBold}
  min-width: 145px;
  padding: 8px;
  display: flex;
  border-radius: 8px;
  background: transparent;
  border: unset;
  &:hover {
    background: ${themeColor('buttonBackgroundHover')};
  }

  ${(props) =>
    props.$selected &&
    css`
      background: ${themeColor('buttonBackgroundHover')};
    `}

  ${clickableMixin}
`;

const Footer = styled.div`
  display: flex;
  justify-content: end;
  gap: 10px;
  overflow: visible;
  .validationError {
    color: ${themeColor('red')};
    position: absolute;
    left: 16px;
    bottom: 30px;
  }
`;

const DatePicker = styled(BaseDatePicker)``;

const CarretIcon = styled(HudIcon).attrs({
  icon: 'menu.caretDown',
  size: '14px',
})<{ icon?: never }>`
  color: ${themeColor('gray')};
`;

const TimePicker = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  &.error input {
    border-color: ${themeColor('red')};
  }
  & input {
    width: 170px;
  }
`;

const TimePickerSpacer = styled.div`
  flex: 1;
  text-align: center;
`;

export default {
  Button,
  Icon,
  Body,
  Title,
  Divider,
  Content,
  Menu,
  MenuOption,
  Footer,
  Guide,
  DotIcon,
  DatePicker,
  CarretIcon,
  TimePicker,
  TimePickerSpacer,
  GrayDot,
};
